import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import color from 'color';
import { black } from '../styles/colors';
import IconButton from '../IconButton';
var AppbarAction = /** @class */function (_super) {
  __extends(AppbarAction, _super);
  function AppbarAction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AppbarAction.prototype.render = function () {
    var _a = this.props,
      _b = _a.color,
      iconColor = _b === void 0 ? color(black).alpha(0.54).rgb().string() : _b,
      icon = _a.icon,
      disabled = _a.disabled,
      onPress = _a.onPress,
      accessibilityLabel = _a.accessibilityLabel,
      rest = __rest(_a, ["color", "icon", "disabled", "onPress", "accessibilityLabel"]);
    return /*#__PURE__*/React.createElement(IconButton, __assign({
      onPress: onPress,
      color: iconColor,
      icon: icon,
      disabled: disabled,
      accessibilityLabel: accessibilityLabel,
      animated: true
    }, rest));
  };
  AppbarAction.displayName = 'Appbar.Action';
  AppbarAction.defaultProps = {
    size: 24
  };
  return AppbarAction;
}(React.Component);
export default AppbarAction;